import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import TaxActionButtons from './actionButtons/TaxActionButtons';
import Button from '../smartAdminUI/Button';

const TaxAutoPopTable = props => {
  const {
    displayData,
    onListingSelected,
    isModal = false,
  } = props;

  const actionsFormatter = (cell, row) => (
    <TaxActionButtons
      listingClicked={onListingSelected}
      index={Number(row.UniqueID)}
    />
  );
  const hdrSortClasses = (_column, sortOrder) => `sorting_${sortOrder}`;

  const generateColumns = () => {
    const columns = [
      {
        dataField: 'actions',
        text: 'Actions',
        formatter: actionsFormatter,
        headerStyle: { width: '55px' },
      },
      {
        dataField: 'ParcelNumber',
        text: 'LincNumber',
        headerSortingClasses: hdrSortClasses,
        headerAttrs: { className: 'sorting' },
        sort: true,
      },
      {
        dataField: 'UnitNumber',
        text: 'Unit #',
        headerSortingClasses: hdrSortClasses,
        headerAttrs: { className: 'sorting' },
        sort: true,
      },
      {
        dataField: 'StreetNumber',
        text: 'Street #',
        headerSortingClasses: hdrSortClasses,
        headerAttrs: { className: 'sorting' },
        sort: true,
      },
      {
        dataField: 'StreetName',
        text: 'Street Name',
        headerSortingClasses: hdrSortClasses,
        headerAttrs: { className: 'sorting' },
        sort: true,
      },
      {
        dataField: 'StreetSuffix',
        text: 'Street Suffix',
        headerSortingClasses: hdrSortClasses,
        headerAttrs: { className: 'sorting' },
        sort: true,
      },
    ];
    return columns;
  };

  const defaultSorted = [{
    dataField: 'UniqueID',
    order: 'desc',
  }];

  // Buttons on the bottom left of the table that allow
  // the user to decide on how many rows per page should
  // be shown at one time.
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <div className="btn-group" role="group">
      {
        options.map(option => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <Button
              variant={`${isSelect ? 'primary' : 'outline-primary'}`}
              key={option.text}
              onClick={() => onSizePerPageChange(option.page)}
            >
              {option.text}
            </Button>
          );
        })
      }
    </div>
  );

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      &nbsp;
      {`Showing rows ${from} to ${to} of ${size}`}
    </span>
  );

  const options = {
    firstPageText: '<<',
    hidePageListOnlyOnePage: true,
    lastPageText: '>>',
    nextPageText: '>',
    paginationTotalRenderer: customTotal,
    prePageText: '<',
    showTotal: true,
    sizePerPageList: [],
    sizePerPage: isModal ? 5 : 10,
    sizePerPageRenderer,
  };

  return (
    <>
      {displayData.length > 0
        ? (
          <BootstrapTable
            columns={generateColumns()}
            data={displayData}
            defaultSorted={defaultSorted}
            wrapperClasses="table-responsive"
            classes="dataTable"
            bordered={false}
            striped
            hover
            id="officesTable"
            keyField="UniqueID"
            noDataIndication="No Data Returned."
            pagination={paginationFactory(options)}
          />
        )
        : (
          <BootstrapTable
            columns={generateColumns()}
            data={displayData}
            defaultSorted={defaultSorted}
            wrapperClasses="table-responsive"
            classes="dataTable"
            bordered={false}
            striped
            hover
            id="officesTable"
            keyField="UniqueID"
            noDataIndication="No Data Returned."
          />
        )}
    </>
  );
};

TaxAutoPopTable.propTypes = {
  displayData: PropTypes.arrayOf(PropTypes.shape()),
  onListingSelected: PropTypes.func.isRequired,
  isModal: PropTypes.bool,
};

export default TaxAutoPopTable;
